// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const AddWidgetIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="add-widget" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><path id="Path" fill="#FFF" d="M2 16h14V2H2z" /><path id="Shape" fill="currentColor" fillRule="nonzero" d="M8 14h2v-4h4V8h-4V4H8v4H4v2h4zm-6 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h14q.824 0 1.413.588Q18 1.175 18 2v14q0 .824-.587 1.413A1.93 1.93 0 0 1 16 18zm0-2h14V2H2zm.038-14v14z" /></g></svg>
))
